import { TAG_CODES } from "../../tag.config"

const GOM_DATA_METEO_WIND = {
    type: 'path',
    tagCode: TAG_CODES.DATA,
    withText: true,
    defaultText: 'Wind',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M19 73 19 8M28 15 19 3 11 15`,
}

export default GOM_DATA_METEO_WIND